module.exports = __webpack_public_path__ + "static/media/image018.144aecb0.png";